import { create } from 'zustand';
import { DateRange } from 'react-day-picker';
import { ColumnState } from 'ag-grid-community';

import { defaultSYS4100_R01Dto, SYS4100_R01Dto } from './Dto_SYS4100_R01';
import { showWarning } from 'src/utils/toast/toastUtil';

export interface SYS4100_R01Filter {
	orgNm: string;
	useYn: string;
}

export interface Store_SYS4100_R01 {
	SYS4100_R01Filter: SYS4100_R01Filter;
	SYS4100_R01PastFilter: SYS4100_R01Filter;
	setSYS4100_R01Filter: (filter: Partial<SYS4100_R01Filter>) => void;
	setSYS4100_R01PastFilter: (filter: Partial<SYS4100_R01Filter>) => void;

	SYS4100_R01List: SYS4100_R01Dto[];
	setSYS4100_R01List: (SYS4100_R01List: SYS4100_R01Dto[]) => void;
	insertSYS4100_R01List: (data: SYS4100_R01Dto[], index?: number) => void;
	removeSYS4100_R01List: (index: number) => void;
	updateSYS4100_R01List: (index: number, SYS4100_R01List: SYS4100_R01Dto) => void;

	deletedSYS4100_R01List: string[];
	addDeletedSYS4100_R01List: (idList: string[]) => void;
	removeDeletedSYS4100_R01List: (idList?: string[]) => void;

	selectedSYS4100_R01List: string[];
	setSelectedSYS4100_R01List: (idList: string[]) => void;
	addSelectedSYS4100_R01List: (idList: string[]) => void;
	removeSelectedSYS4100_R01List: (idList?: string[]) => void;
	initSelectedSYS4100_R01List: () => void;
	allSelectedSYS4100_R01List: () => void;

	originalSYS4100_R01List: SYS4100_R01Dto[];
	setOriginalSYS4100_R01List: (list: SYS4100_R01Dto[]) => void;

	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	

	initData: () => void;

}

export interface Store_SYS4100_R01_GridCalendarState {

	// ====== SYS4100_R01 GridCalendar 상태 ======
	SYS4100_R01GridCalendarState: {
		pickerVisible: boolean;
		pickerPosition: { top: number; left: number };
		targetRowIndex: number | null;
		targetField: string | null;
		targetDate: Date | undefined;
	};
	setSYS4100_R01GridCalendarState: (state: Partial<Store_SYS4100_R01_GridCalendarState['SYS4100_R01GridCalendarState']>) => void;
	initSYS4100_R01GridCalendarState: () => void;

}

export const defaultSYS4100_R01Filter: SYS4100_R01Filter = {
	orgNm: '',
	useYn: ''
};

export const useSYS4100_R01Store = create<Store_SYS4100_R01>((set) => ({
	SYS4100_R01Filter: defaultSYS4100_R01Filter,
	SYS4100_R01PastFilter: defaultSYS4100_R01Filter,
	setSYS4100_R01Filter: (update) => set((state) => ({
		SYS4100_R01Filter: {
			...state.SYS4100_R01Filter,
			...update
		}
	})),
	setSYS4100_R01PastFilter: (update) => set((state) => ({
		SYS4100_R01PastFilter: {
			...state.SYS4100_R01PastFilter,
			...update
		}
	})),

	SYS4100_R01List: [],
	setSYS4100_R01List: (SYS4100_R01List: SYS4100_R01Dto[]) => set((state) => {
		let newList: SYS4100_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		SYS4100_R01List.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultSYS4100_R01Dto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			SYS4100_R01List: newList
		}
	}),
	insertSYS4100_R01List: (data: SYS4100_R01Dto[], index?: number) => set((state) => {
		let newSYS4100_R01List = [...state.SYS4100_R01List];

		let targetRowData = newSYS4100_R01List.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		console.log('targetOrderIndex : ', targetOrderIndex);
		console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newSYS4100_R01List.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newSYS4100_R01List.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newSYS4100_R01List = newSYS4100_R01List.filter(item => item.orderIndex !== targetOrderIndex);
		newSYS4100_R01List.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultSYS4100_R01Dto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		// console.log('newData : ', newData);
		if (index !== undefined) {
			newSYS4100_R01List.splice(index, 0, ...newData);
		} else {
			newSYS4100_R01List.push(...newData);
		}

		return {
			...state,
			SYS4100_R01List: newSYS4100_R01List
		}
	}),
	removeSYS4100_R01List: (index: number) => set((state) => {
		const newSYS4100_R01List = [...state.SYS4100_R01List].filter((item) => item.valueIndex !== index);
		return {
			...state,
			SYS4100_R01List: newSYS4100_R01List
		}
	}),
	updateSYS4100_R01List: (valueIndex: number, data: SYS4100_R01Dto) => set((state) => {
		const _SYS4100_R01List = state.SYS4100_R01List.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		if(data.displaySeq && data.displaySeq < 1) {
			showWarning('순서는 1보다 작을 수 없습니다.');
			data.displaySeq = 1;
		}
		return {
			...state,
			SYS4100_R01List: _SYS4100_R01List
		}
	}),


	deletedSYS4100_R01List: [],
	addDeletedSYS4100_R01List: (idList: string[]) => set((state) => {
		const _deletedSYS4100_R01List = [...state.deletedSYS4100_R01List];

		for(const valueIndex of idList) {
			const isInserted = state.SYS4100_R01List.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.SYS4100_R01List.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedSYS4100_R01List.push(valueIndex);
			}
		}
		return {
			...state,
			deletedSYS4100_R01List: _deletedSYS4100_R01List
		}
	}),
	removeDeletedSYS4100_R01List: (idList?: string[]) => set((state) => ({
		...state,
		deletedSYS4100_R01List: [...state.deletedSYS4100_R01List].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedSYS4100_R01List: [],
	setSelectedSYS4100_R01List: (idList: string[]) => set({ selectedSYS4100_R01List: idList }),
	addSelectedSYS4100_R01List: (idList: string[]) => set((state) => {
		const _selectedSYS4100_R01List = [...state.selectedSYS4100_R01List];
		if(idList.length > 0) {
			_selectedSYS4100_R01List.push(...idList);
		}
		return {
			...state,
			selectedSYS4100_R01List: _selectedSYS4100_R01List
		}
	}),
	removeSelectedSYS4100_R01List: (idList?: string[]) => set((state) => ({
		...state,
		selectedSYS4100_R01List: [...state.selectedSYS4100_R01List].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedSYS4100_R01List: () => set({ selectedSYS4100_R01List: [] }),
	allSelectedSYS4100_R01List: () => set((state) => {
		const _selectedSYS4100_R01List = [...state.SYS4100_R01List.map(item => item.valueIndex.toString())];
		return {
			...state,
			selectedSYS4100_R01List: _selectedSYS4100_R01List
		}
	}),

	originalSYS4100_R01List: [],
	setOriginalSYS4100_R01List: (SYS4100_R01List: SYS4100_R01Dto[]) => set((state) => {
		let newList: SYS4100_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		SYS4100_R01List.forEach((item, index) => {
			newList.push({ 
				...defaultSYS4100_R01Dto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalSYS4100_R01List: newList
		}
	}),
	
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

	initData: () => set((state) => ({
		...state,
		SYS4100_R01Filter: defaultSYS4100_R01Filter,
		SYS4100_R01PastFilter: defaultSYS4100_R01Filter,
		SYS4100_R01List: [],
		selectedSYS4100_R01List: [],
		deletedSYS4100_R01List: [],
		allCount: 0,
		scrollTop: null,
	})),

}));


export const useSYS4100_R01Store_GridCalendar = create<Store_SYS4100_R01_GridCalendarState>((set) => ({

	// ====== GridCalendar 상태 ======
	SYS4100_R01GridCalendarState: {
		pickerVisible: false,
		pickerPosition: { top: 0, left: 0 },
		targetRowIndex: null,
		targetField: null,
		targetDate: undefined
	},
	setSYS4100_R01GridCalendarState: (newState: Partial<Store_SYS4100_R01_GridCalendarState['SYS4100_R01GridCalendarState']>) => set((state) => ({
		...state,
		SYS4100_R01GridCalendarState: { ...state.SYS4100_R01GridCalendarState, ...newState }
	})),
	initSYS4100_R01GridCalendarState: () => set((state) => ({
		...state,
		SYS4100_R01GridCalendarState: {
			pickerVisible: false,
			pickerPosition: { top: 0, left: 0 },
			targetRowIndex: null,
			targetField: null,
			targetDate: undefined
		}
	})),


})); 